import React from 'react'
import { 
  Button,
  Divider
} from 'semantic-ui-react'

import { 
  FileCont } from './styled'

export const FileRow = (props) => {

  return (
    <FileCont>
      <div className='titleFile'>{`${props.attachmentTitle||''} : `}</div>
      <div className='fileItem'>
        {
          props.files.length!==0?
          props.files.map((item)=>{
            // return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(item.urlPath,"_blank"))}/>
            return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = item.urlPath)}/>
          })
          :
          <div className='noFile'>There is no attachment.</div>
        }
        <Divider/>
      </div>
    </FileCont>
  )
}